export * from "./api.service";
export * from "./inventory.service";
export * from "./storage.service";
export * from "./user.service";
export * from "./toast.service";
export * from "./cm.service";
export * from "./resource.service";
/* Purchase management */
export * from "./pm.service";
// Administration management
export * from "./admin.service"
export * from "./menu.service"
export * from "./prd.service"



// WEBPACK FOOTER //
// ./src/services/index.js